import PrimaryPageContainer from "../components/containers/PrimaryPageContainer.jsx";
import SpinSpinnerSection from "../sections/spin/SpinSpinnerSection.jsx";

function SpinPage() {
  return (
    <PrimaryPageContainer transparent>
      <SpinSpinnerSection />
    </PrimaryPageContainer>
  );
}

export default SpinPage;
